import * as React from 'react';
import './PaymentHistoryItem.css';
    
export interface PaymentHistoryItemProps {
    amount: string;
    date: string;
    status: string;
    id: string;
    isSpecialDebit: boolean;
    emitHandleScheduleSpecialDebit;
    emitHandleRetryPayment;
}

export class PaymentHistoryItem extends React.Component<PaymentHistoryItemProps, any> {
    constructor(props: PaymentHistoryItemProps) {
        super(props);
        
        this.state = {
            statusImageMap: {
                'Payment pending': './Images/LifeInsurance/Checkmark.svg',
                'Payment successful': './Images/LifeInsurance/Checkmark.svg',
                'Payment failed': './Images/OnlineQuotes/icons-checkmark-default-cross-24-px.svg',
                'Special debit payment failed': './Images/OnlineQuotes/icons-checkmark-default-cross-24-px.svg',
            },
        }
        
        this.handleScheduleSpecialDebit = this.handleScheduleSpecialDebit.bind(this);
        this.handleRetryPayment = this.handleRetryPayment.bind(this);
    }
    
    async handleScheduleSpecialDebit(e: any) {
        this.props.emitHandleScheduleSpecialDebit(this.props.id);
    }

    async handleRetryPayment(e: any) {
        this.props.emitHandleRetryPayment(this.props.id);
    }
    
    public render() {
        return (
            <div className="payment-history__item row p-2">
                <div className="col-lg-5 col-5">
                    <p className="item item__amount font-weight-bold">R {this.props.amount}</p>
                </div>
                <div className="col-lg-7 col-7 text-right">
                    <p className="item item__date text-right">{this.props.date}</p>
                    <p className="item item__status font-weight-bold text-right">
                        <span>{this.props.status}</span>
                        <span className="ml-1">
                            <img height="18px" src={this.state.statusImageMap[this.props.status]} />
                        </span>
                    </p>
                </div>
                <div className="col-12 payment-history__actions">
                    {
                        this.props.status == "Payment failed" || this.props.status == "Special debit payment failed" &&
                        <button onClick={this.handleScheduleSpecialDebit} id="payment-history-item__schedule-special-debit" className="d-inline-block btn-outline-red mt-2">Schedule special debit</button>
                    }
                    {
                        this.props.isSpecialDebit &&
                        <button onClick={this.handleRetryPayment} className="payment-history__retry-payment d-inline-block btn-solid-red mt-2">Retry payment</button>
                    }
                </div>
            </div>
        )
    }
}
